var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',[_c('v-list',_vm._l((_vm.orders),function(orderItem,orderIndex){return _c('Order',{key:orderIndex,attrs:{"order":orderItem}})}),1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }